/**
 * Jelszó visszaállítás feature szövegei
 *
 * Namespace: resetPassword
 */
export const resetPassword = {
  // Oldal
  page: {
    title: "Új jelszó megadása",
    subtitle: "Add meg az új jelszavad",
  },

  // Űrlap mezők
  form: {
    passwordLabel: "Új jelszó",
    passwordPlaceholder: "••••••••",
    passwordHelperText: "Legalább 6 karakter",
    confirmPasswordLabel: "Jelszó megerősítése",
    confirmPasswordPlaceholder: "••••••••",
    submitButton: "Megerősítés",
    loadingButton: "Megerősítés...",
  },

  // Sikeres visszaállítás
  success: {
    title: "Jelszó megváltoztatva!",
    message: "A jelszavad sikeresen megváltozott. Most már bejelentkezhetsz az új jelszavaddal.",
    goToLogin: "Tovább a bejelentkezéshez",
  },

  // Hibák
  errors: {
    invalidToken: "A jelszó-visszaállító link érvénytelen vagy lejárt.",
    expiredToken: "A jelszó-visszaállító link lejárt. Kérj egy új linket.",
  },
} as const;

export type ResetPasswordMessages = typeof resetPassword;
